import { CSSProperties, memo } from 'react'

import { RevenueImpactDeal, formatDealAmount } from '../utils'
import styles from './Deal.module.scss'

import Button from '~elements/Button'
import CloseIcon from '~icons/newDesign/close-small.svg'
import Avatar from '~lib/ui-kit/Avatar'
import Box from '~lib/ui-kit/Box'
import Col from '~lib/ui-kit/Col'
import Row from '~lib/ui-kit/Row'
import Text from '~lib/ui-kit/Text'

interface DealProps {
  deal: RevenueImpactDeal
  onDealRemove?: (id: string) => void
}

function Deal({ deal, onDealRemove }: DealProps) {
  return (
    <Box variant="light" borderRadius="sm" className={styles.root}>
      <Row align="center" gutter="1" wrap={false}>
        <Col>
          <Avatar size="sm" alt={deal.name} src={deal.company?.logo} color={deal.color} />
        </Col>

        <Col flex={1}>
          <Text>{deal.name}</Text>
        </Col>

        <Col>
          <Text>{formatDealAmount(deal.amount)}</Text>
        </Col>

        <Col>
          <span className={styles.square} style={{ backgroundColor: deal.color } as CSSProperties} />
        </Col>
        {onDealRemove && (
          <Button variant="plain" className="ml-1" icon={<CloseIcon />} onClick={() => onDealRemove(deal.id)} />
        )}
      </Row>
    </Box>
  )
}

export default memo(Deal)
